import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { Procedures } from './Procedures';

const ProceduresBridge = react2angular(Procedures, ['backFromState']);

export default ProceduresBridge;
